module.exports = __webpack_public_path__ + "img/logo_square_blue.48fd96e3.png";